/**
 * BLOCK: Footer Block.
 */
import { __ } from '@wordpress/i18n'
import { disabledBlocks, srcUrl, i18n } from 'cartzillagb'
import { BlogPostsIcon } from '~cartzillagb/icons'

import DefaultImage  from  './images/img1.png'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

const schema = {
    uniqueClass: {
        type: 'string',
    },
    className: {
        type: 'string',
    },

    design: {
        type: 'string',
        default: 'v1',
    },

    footerType: {
        type: 'string',
        default: 'dark',
    },
    enableFooterWidgets: {
        type: 'boolean',
        default: true,
    },

    enableFooterStaticContent: {
        type: 'boolean',
        default: true,
    },

    enableFooterMenu: {
        type: 'boolean',
        default: true,
    },

    enableFooterSocialMenu: {
        type: 'boolean',
        default: true,
    },

    enableFooterPayment: {
        type: 'boolean',
        default: true,

    },

    enableFooterCopyright: {
        type: 'boolean',
        default: true,
    },

    copyrightText: {
        type: 'string',
        default: __( '&copy; All rights reserved. Made by <a href="https://createx.studio/" target="_blank" rel="noopener noreferrer">Createx Studio</a>',i18n )
    },

    footerStaticContentId: {
        type: 'number',
    },

    footerWidgetColumn1: {
        type: 'string',
         default: 'footer-column-1',
    },

    footerWidgetColumn2: {
        type: 'string',
         default: 'footer-column-2',
    },

    footerWidgetColumn3: {
        type: 'string',
         default: 'footer-column-3',
    },

    copyrightAlignment: {
        type: 'string',
         default: 'left',
    },
    logoImageID: {
        type: 'number',
    },
    logoImageUrl: {
        type: 'string',
    },

    footerPrimaryMenuSlug : {
        type: 'string',
    },

    enableLogoTitle : {
        type: 'boolean',
        default: true,
    },
    additionalClass : {
        type: 'string',
    },
    logoImageID1: {
        type: 'number',
    },
    logoImageUrl1: {
        type: 'string',
        default: `${ srcUrl }/${ DefaultImage }`
    },
    enableLanguageCurrency: {
        type: 'boolean',
        default: true,
    },

    enableFooterStatistics: {
        type: 'boolean',
        default: true,
    },

    footerSiteTitle: {
        type: 'string',
         default: __( 'Marketplace', i18n )
    },

    footerSiteDesc: {
        type: 'string',
         default: __( 'High quality items created by our global community.', i18n)
    }, 
    
}

export const name = 'czgb/footer'

export const settings = {
    title: __( 'Footer' ),
    description: __( 'A website footer is found at the bottom of your site pages. It typically includes important informations.' ),
    icon: BlogPostsIcon,
    example: {},
    category: 'cartzillagb',
    keywords: [
        __( 'Footer' ),
        __( 'CartzillaGb' ),
    ],
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },
    attributes: schema,

    edit,
    save,

    // CartzillaGB modules.
    // modules: {
    //     'advanced-responsive': true,
    // },
}